import { IModuleTranslation } from '@larscom/ngx-translate-module-loader';
import { trackerTypeBloodPressure } from './blood-pressure/blood-pressure.interface';
import { trackerTypeCalories } from './calories/calories.interface';
import { trackerTypeDistance } from './distance/distance.interface';
import { trackerTypeHeartRate } from './heart-rate/heart-rate.interface';
import { trackerTypeHRV } from './hrv/hrv.interface';
import { trackerTypeOxygenSaturation } from './oxygen-saturation/oxygen-saturation.interface';
import { trackerTypeSkinOrBodyTemperature } from './skin-or-body-temperature/skin-or-body-temperature.interface';
import { trackerTypeSleep } from './sleep/sleep.interface';
import { trackerTypeSleepScore } from './sleep-score/sleep-score.interface';
import { trackerTypeSteps } from './steps/steps.interface';
import { trackerTypeVO2Max } from './vo2-max/vo2-max.interface';

export const trackerType: Array<IModuleTranslation> = [
  ...trackerTypeBloodPressure,
  ...trackerTypeCalories,
  ...trackerTypeDistance,
  ...trackerTypeHeartRate,
  ...trackerTypeOxygenSaturation,
  ...trackerTypeSleep,
  ...trackerTypeSteps,
  ...trackerTypeSleepScore,
  ...trackerTypeHRV,
  ...trackerTypeVO2Max,
  ...trackerTypeSkinOrBodyTemperature
];
